/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.0 ./public/67896f1a3cb779dd7d6a1e7a.glb -o src/components/Avatar.jsx -r /public 
*/

import React,{useEffect, useRef} from 'react'
import { useGraph } from '@react-three/fiber'
import { useFBX, useGLTF,useAnimations } from '@react-three/drei'
import { SkeletonUtils } from 'three-stdlib'


export function Model({ sessionStarted, talking, ...props }) {
  const { scene } = useGLTF('/67896f1a3cb779dd7d6a1e7a.glb');
  const clone = React.useMemo(() => SkeletonUtils.clone(scene), [scene]);
  const { nodes, materials } = useGraph(clone);
  const { animations: idle } = useFBX('/animations/Happy Idle.fbx');
  const { animations: talk1 } = useFBX('/animations/Talking.fbx');
  const { animations: wave } = useFBX('/animations/Waving.fbx');
  const { animations: talk2 } = useFBX('/animations/Talking (1).fbx');
  const { animations: talk3 } = useFBX('/animations/Talking (2).fbx');

  idle[0].name = "Happy Idle";
  talk1[0].name = "Talking";
  wave[0].name = "Waving";
  talk2[0].name = "Talking 2";
  talk3[0].name = "Talking 3";

  const group = useRef();
  const { actions } = useAnimations([idle[0], talk1[0], wave[0], talk2[0],talk3[0]], group);

  useEffect(() => {
    console.log('Avatar sessionStarted:', sessionStarted, 'talking:', talking);
  
    // Stop all animations before switching to a new one
    Object.values(actions).forEach(action => action.stop());
  
    if (!sessionStarted) {
      console.log('Playing Waving animation');
      actions["Waving"]?.reset().fadeIn(0.5).play();
    } else if (talking) {
      const talkingAnimations = ["Talking", "Talking 2", "Talking 3"];
    const randomTalking = talkingAnimations[Math.floor(Math.random() * talkingAnimations.length)];

    console.log(`Playing ${randomTalking} animation`);
    actions[randomTalking]?.reset().fadeIn(0.5).play();

    } else {
      console.log('Returning to Idle');
      actions["Happy Idle"]?.reset().fadeIn(0.5).play();
    }
  }, [sessionStarted, talking, actions]);

  return (
    <group {...props} dispose={null} ref={group}>
      <primitive object={nodes.Hips} />
      <skinnedMesh geometry={nodes.Wolf3D_Hair.geometry} material={materials.Wolf3D_Hair} skeleton={nodes.Wolf3D_Hair.skeleton} />
      <skinnedMesh geometry={nodes.Wolf3D_Outfit_Bottom.geometry} material={materials.Wolf3D_Outfit_Bottom} skeleton={nodes.Wolf3D_Outfit_Bottom.skeleton} />
      <skinnedMesh geometry={nodes.Wolf3D_Outfit_Footwear.geometry} material={materials.Wolf3D_Outfit_Footwear} skeleton={nodes.Wolf3D_Outfit_Footwear.skeleton} />
      <skinnedMesh geometry={nodes.Wolf3D_Outfit_Top.geometry} material={materials.Wolf3D_Outfit_Top} skeleton={nodes.Wolf3D_Outfit_Top.skeleton} />
      <skinnedMesh name="EyeLeft" geometry={nodes.EyeLeft.geometry} material={materials.Wolf3D_Eye} skeleton={nodes.EyeLeft.skeleton} morphTargetDictionary={nodes.EyeLeft.morphTargetDictionary} morphTargetInfluences={nodes.EyeLeft.morphTargetInfluences} />
      <skinnedMesh name="EyeRight" geometry={nodes.EyeRight.geometry} material={materials.Wolf3D_Eye} skeleton={nodes.EyeRight.skeleton} morphTargetDictionary={nodes.EyeRight.morphTargetDictionary} morphTargetInfluences={nodes.EyeRight.morphTargetInfluences} />
      <skinnedMesh name="Wolf3D_Head" geometry={nodes.Wolf3D_Head.geometry} material={materials.Wolf3D_Skin} skeleton={nodes.Wolf3D_Head.skeleton} morphTargetDictionary={nodes.Wolf3D_Head.morphTargetDictionary} morphTargetInfluences={nodes.Wolf3D_Head.morphTargetInfluences} />
      <skinnedMesh name="Wolf3D_Teeth" geometry={nodes.Wolf3D_Teeth.geometry} material={materials.Wolf3D_Teeth} skeleton={nodes.Wolf3D_Teeth.skeleton} morphTargetDictionary={nodes.Wolf3D_Teeth.morphTargetDictionary} morphTargetInfluences={nodes.Wolf3D_Teeth.morphTargetInfluences} />
      <skinnedMesh name="Wolf3D_Beard" geometry={nodes.Wolf3D_Beard.geometry} material={materials.Wolf3D_Beard} skeleton={nodes.Wolf3D_Beard.skeleton} morphTargetDictionary={nodes.Wolf3D_Beard.morphTargetDictionary} morphTargetInfluences={nodes.Wolf3D_Beard.morphTargetInfluences} />
    </group>
  );
}


useGLTF.preload('/67896f1a3cb779dd7d6a1e7a.glb')
